import InputField from "@metacrm/metacrm-material-ui/dist/InputField";
import { Box } from "@mui/material";
import React, { useEffect, useMemo, useRef, useState } from "react";
import Grid from "@metacrm/metacrm-material-ui/dist/Grid";
import RunTest from "../../components/RunTest";
import { StyledWhiteContainer } from "features/metadesk/settings/common.styles";
import {
  Button,
  SIZE,
  VARIANT,
} from "@metacrm/metacrm-material-ui/dist/Button";
import { useIntl } from "react-intl";
import {
  useFetchEntityConfig,
  useFetchOptInConfig,
} from "features/metadesk/redux/hooks";
import useDispatchSnackbar from "hooks/useDispatchSnackbar";
import { useOutletContext } from "react-router";
import _, { get, isEmpty } from "lodash";
import SaveDiscardActions from "features/metadesk/settings/integrations/components/SaveDiscardActions";

export default function General({
  data,
  handleRefetch,
  setHasChanges,
  hasSaved,
  setHasSaved,
}) {
  const initialDomainName = data?.url?.replace(/^https?:\/\//, "") || "";
  const [entityName] = useOutletContext();
  const [domainName, setDomainName] = useState(initialDomainName || "");

  const { formatMessage } = useIntl();
  const dispatchSnackbar = useDispatchSnackbar();
  const { updateOptInConfig } = useFetchOptInConfig();
  const { entityConfig } = useFetchEntityConfig();
  const hasService = get(entityConfig, "modules.service");

  // 用來保存初始狀態的 Ref
  const firstFetchData = useRef({
    domainName: initialDomainName,
  });

  const { _id } = data;

  const saveConfig = async () => {
    try {
      await updateOptInConfig({
        entityName,
        config: {
          url: domainName !== "" ? `https://${domainName}` : "",
          websiteOptInId: get(data, "_id"),
        },
      });
      await handleRefetch();
      firstFetchData.current = {
        domainName: domainName,
      };
      setHasChanges(false);
      dispatchSnackbar({
        message: formatMessage({
          id: "websiteOptIn.configure.saveSuccess",
        }),
        variant: "success",
      });
    } catch (err) {
      dispatchSnackbar({ err });
    }
  };

  // 處理 Discard 按鈕點擊事件
  const handleDiscard = () => {
    setDomainName(firstFetchData.current.domainName);

    setHasChanges(false);
  };

  // 判斷 Save 按鈕是否需要禁用
  const isSaveDisabled = useMemo(() => {
    return domainName === firstFetchData.current.domainName;
  }, [domainName]);

  useEffect(() => {
    setHasChanges(!isSaveDisabled);
  }, [isSaveDisabled, setHasChanges]);

  return (
    <div className="fade-up-more">
      <StyledWhiteContainer sx={{ padding: "32px", margin: "12px 0" }}>
        <Box>
          <Grid container spacing={2}>
            <Grid item xs={12} md={4}>
              <Box color="#555" fontSize="16px">
                {formatMessage({ id: "widgetSettings.domain.input" })}
              </Box>
            </Grid>
            <Grid item xs={12} md={8}>
              <InputField
                placeholder="example.com"
                prefixWord="https://"
                value={domainName}
                onChange={(e) => {
                  setDomainName(e.target.value);
                }}
              />
            </Grid>
          </Grid>
        </Box>
      </StyledWhiteContainer>
      <RunTest
        apiPath={`websiteOptInConfig`}
        title={formatMessage({
          id: "notification.subscribeBtn.installCheckTitle",
        })}
        description={formatMessage({
          id: "notification.subscribeBtn.installCheckDesc",
        })}
        label={formatMessage({
          id: "notification.subscribeBtn.installCheckTitle",
        })}
      />
      <SaveDiscardActions
        onDiscard={handleDiscard}
        onSave={saveConfig}
        isDisabled={isSaveDisabled}
        hasSaved={hasSaved}
        setHasSaved={setHasSaved}
      />
    </div>
  );
}
